"use client";

import { WishlistButton } from "@/components/atoms/Wishlist/WishlistButton";
import useSizes from "../../hooks/useSizes";
import { PDPProduct } from "../../page";

export const WishlistToggle = ({
  product,
  className,
}: {
  product: PDPProduct;
  className?: string;
}) => {
  const sizes = useSizes(product?.sizes);
  const itemId = sizes?.selectedSize?.itemId || product?.itemId;

  return <WishlistButton itemId={itemId} className={className} />;
};
